import React, { useEffect } from "react";

import { _goToBack } from "routers/helper";
import { useNavigation } from "@react-navigation/native";

import { View, ViewProps, StyleSheet } from "react-native";

import Text from "components/Text";
import ImgIcon from "components/imgIcon";

import { mq } from "utils";
import { icon } from "assets/images";
import Button from "components/Button";
import { colors, sizes, strings } from "assets/constants";
import { useEject } from "hooks";

export default function Empty(props: ErrorT & ViewProps) {
  const { error, loading, reset } = props;
  const eject = useEject();

  const networkError = error?.code === "ERR_NETWORK";
  const notFound = error?.response?.status === 404;

  useEffect(() => {
    if (error?.response?.status === 401) {
      eject();
    }
  }, [error?.response?.status]);

  return (
    <View style={[styles.container]}>
      <ImgIcon
        size={mq(128)}
        color={networkError ? "#3c638255" : undefined}
        icon={
          notFound
            ? icon.notFound
            : networkError
            ? icon.networkError
            : icon.error
        }
        style={{ marginBottom: sizes.space }}
      />

      <Text color={colors.textColorDark} weight="bold" size={"xxl"}>
        {networkError
          ? strings.connection_error
          : notFound
          ? strings._404_error
          : strings.server_error}
        !
      </Text>

      <Button
        onPress={notFound ? _goToBack : reset ? reset : undefined}
        loading={loading}
        width="auto"
        height={mq(35)}
        title={{
          value: notFound ? strings.return : strings.do_again,
          color: colors.info,
        }}
        icon={{
          name: notFound ? "corner-up-right" : "rotate-cw",
        }}
        bgColor={colors.transparent}
        style={{ paddingHorizontal: mq(20), margin: mq(30) }}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, alignItems: "center", justifyContent: "center" },
});
